import { ArrowDown, Minimize2, Plus, Puzzle, ScanSearch, Target, TrendingUp, Users } from 'lucide-react';
import { T } from '../../i18n/copy';
import Reveal from '../Reveal';
import SectionHead from '../SectionHead';

const ICONS = [ScanSearch, Target, Puzzle, Minimize2, Users, TrendingUp];

export default function Principles({ lang }) {
  const t = T.principles;
  return (
    <section data-header-theme="bone" data-testid="principles-section" className="editorial-margins bg-bone py-10 md:py-12">
      <SectionHead eyebrow={t.eyebrow[lang]} index={t.index} />
      <Reveal className="mt-10">
        <h2 className="font-tight font-semibold text-[clamp(1.75rem,2.6vw,2.4rem)] leading-[1.08] tracking-[-0.02em] text-midnight">
          {t.headline[lang]}
        </h2>
      </Reveal>

      <div className="mt-6 sm:hidden" data-testid="principles-accordion">
        {t.items[lang].map((item, i) => {
          const Icon = ICONS[i];
          return (
            <details key={item.title} data-testid={`principle-mobile-${i}`} className="group border-t border-midnight/12">
              <summary className="flex cursor-pointer list-none items-center gap-3 py-4">
                <Icon className="h-4 w-4 shrink-0 text-vermilion" strokeWidth={1.5} />
                <span className="flex-1 text-base font-medium text-midnight">{item.title}</span>
                <Plus className="h-4 w-4 shrink-0 text-midnight/40 transition-transform duration-200 group-open:rotate-45" strokeWidth={1.5} />
              </summary>
              <p className="pb-5 pr-2 text-base leading-relaxed text-midnight/65">{item.desc}</p>
            </details>
          );
        })}
      </div>

      <div className="mt-8 hidden gap-x-10 gap-y-8 sm:grid sm:grid-cols-2 lg:grid-cols-3" data-testid="principles-grid">
        {t.items[lang].map((item, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={item.title} delay={i * 0.06} testid={`principle-${i}`}>
              <div className="border-t border-midnight/15 pt-6">
                <Icon className="h-4 w-4 text-vermilion" strokeWidth={1.5} />
                <h3 className="mt-4 text-base font-medium text-midnight">{item.title}</h3>
                <p className="mt-2 max-w-[30ch] text-base leading-relaxed text-midnight/65">{item.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <div className="mt-8 flex items-start gap-3 border-t border-midnight/15 pt-5">
        <ArrowDown className="mt-1.5 h-4 w-4 shrink-0 text-vermilion" strokeWidth={1.5} />
        <p className="font-serif text-xl leading-snug text-midnight md:text-2xl" data-testid="principles-closing">
          {t.closing[lang][0]}
          <br />
          {t.closing[lang][1]}
        </p>
      </div>
    </section>
  );
}
